import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: InlineAlert = {
  visible: false,
};

const slice = createSlice({
  name: 'inlineAlert',
  initialState: initialState,
  reducers: {
    setInlineAlert(state, action: PayloadAction<InlineAlert>) {
      return action.payload;
    },
  },
});

export const { setInlineAlert } = slice.actions;

export default slice.reducer;
